// extracted by mini-css-extract-plugin
export default {"to_left":"styles_to_left__HGtSB","to_right":"styles_to_right__lPrT3","plus_img":"styles_plus_img__5osNp"};